import ApiUrl from "../../../configTools/api";
// Guarantees the callback fires exactly once with an array, even on failure - the page
// clears its loading flag inside it, so a dropped request must not leave a shimmer spinning.
import { apiGetList } from "../../../configTools/apiGet";
const User = JSON.parse(localStorage.getItem("user-info"));

const Get = (setValues, setPages, page = 1, limit = 20, search = '', filters = {}) => {
    const params = new URLSearchParams({ page, limit });
    if (search) params.set('q', search);
    if (filters.month) params.set('month', filters.month);
    if (filters.year) params.set('year', filters.year);
    if (filters.from) params.set('from', filters.from);
    if (filters.to) params.set('to', filters.to);
    return apiGetList(ApiUrl.LabAdmin_Billing + `?${params.toString()}`, (list, body)=>{
        // the server orders the rows now - no client-side sort
        setValues(list);
        if (setPages) setPages({
            total: body.total || 0,
            pages: body.pages || 1,
            page: body.page || 1,
            // `years` feeds the year dropdown and is NOT part of `response`, so it comes off
            // the raw body like the pagination fields.
            years: body.years || []
        });
    });
}


const Post = (body,refresh,toast,toastid,reset) => {
    fetch(ApiUrl.LabAdmin_Billing,{
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        },
        body: JSON.stringify(body)
    })
    .then(res=>res.json())
    .then(data =>{
        if(data.success){
            setTimeout(() => {
              toast.update(toastid, { render: "Added", type: "success", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
            }, 500);
            // reload keeping the current page and filters
            if (refresh) refresh();
            // Hand the new bill's id to the callback - it opens the statement, which needs it
            // for the Bill No. The API has always returned it; it used to be discarded here.
            reset(data.id);
        }
        else{
            setTimeout(() => {
              toast.update(toastid, { render: data.response, type: "error", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
            }, 500);
        }
    });
}

const Delete = (id,setValues,toast,toastid) => {
    fetch(ApiUrl.LabAdmin_Billing+"/"+id,{
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        }
    })
    .then(res=>res.json())
    .then(data =>{
        if(data.success){
            setTimeout(() => {
              toast.update(toastid, { render: "Deleted", type: "success", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
            }, 500);
            // drop the row locally so the current page/filters are preserved
            setValues(prev => prev.filter(item => item.id !== id));
        }
        else{
            setTimeout(() => {
              toast.update(toastid, { render: data.response, type: "error", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
            }, 500);
        }
    });
}

const Functions = {Get, Post, Delete};
export default Functions;